import { useHostStoreConnect, staticState } from '@wellesley/host-remote'
import { useHostFetch } from '@wellesley/openapi'
import { FC, memo, useRef } from 'react'

export const RemoteApp: FC<{ src: string; name?: string }> = ({
  src,
  name = 'Remote App',
}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null)
  useHostStoreConnect(iframeRef)
  useHostFetch(iframeRef)

  return (
    <iframe
      ref={iframeRef}
      id="remote-app"
      src={`${src}?${staticState.create()}`}
      title={name}
      width="100%"
      height="100%"
      allow="clipboard-write clipboard-read"
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
      allowFullScreen
    />
  )
}

export const MemoizedRemoteApp = memo(RemoteApp)
